export class FileAttachment {
  public id: string;
  public weight: number;
  public entityType: string;
  public entityId: string;
  public originalFileName: string;
  public fileName: string;
  public container: string;
  public contentType: string;
  public url: string;
  public content: Blob;
  public created: Date;

  constructor(init?: Partial<FileAttachment>) {
    Object.assign(this, init);

    if (init && init.created) {
      if (typeof init.created === 'string') {
        // Parse the string as UTC, preserving the exact time in the string
        this.created = new Date(init.created);
      } else if (init.created instanceof Date) {
        // Convert Date to ISO string and reparse to ensure UTC, avoiding local time bias
        this.created = new Date(init.created.toISOString());
      } else {
        this.created = undefined;
      }
    }
  }
}
